import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth, tooltipClick } from '@/components/TableCell';
import { ReconciliationCycleFields as rcf } from '../../../types';
import { TableActionType as ta } from '@/util/enum';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '手机号',
            dataIndex: rcf.tel,
            key: rcf.tel,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => tooltipClick(text, () => { this.props.tableAction(item[rcf.id], 'detail', item); })
        },
        {
            title: '企业名称',
            dataIndex: rcf.enterpriseName,
            key: rcf.enterpriseName,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对账周期',
            dataIndex: rcf.reconciliationCycle,
            key: rcf.reconciliationCycle,
            width: cellWidth.time,
            align: 'center',
            render: (text) => <div>每月{text}号</div>
        },
        {
            title: '注册时间',
            dataIndex: rcf.createTime,
            key: rcf.createTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            width: cellWidth.normal,
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (text, item) => this._renderActionCell(item[rcf.id], item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;

        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, ta.detail, item)}>查看详情</div>
                <div className={styles.item} onClick={() => tableAction(key, ta.sure, item)}>设置对账周期</div>
            </div>
        );
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record[rcf.id]}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    showAudit: PropTypes.bool,
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;